import { Icon } from '@ps/isp-web-component-library';
import { Betslip } from '@ps/isp-web-component-library/icons/Betslip';
import { Size } from '@ps/web-core-enums';
import { Translation, useScreenSize } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import ElementWithCount from '../../../../../ElementWithCount/ElementWithCount';
import BetSlipHeaderDetails from '../../../BetSlipHeaderDetails/BetSlipHeaderDetails';
import OpenMobileBetSlipHeaderContent from '../OpenMobileBetSlipHeader/OpenMobileBetSlipHeaderContent';

import { TXTWCL_Bet_Slip } from './BetSlipHeaderContent.messages.json';
import styles from './BetSlipHeaderContent.scss';

enum HeaderType {
  MobileClosed = 'mobileClosed',
  MobileAuthenticatedOpened = 'mobileAuthenticatedOpened',
  Default = 'default'
}

const getHeaderType = (
  isSmallScreen: boolean,
  isBetSlipOpen: boolean,
  isClientAuthenticated: boolean
): HeaderType => {
  if (isClientAuthenticated && isBetSlipOpen && isSmallScreen) {
    return HeaderType.MobileAuthenticatedOpened;
  }

  if (isSmallScreen && !isBetSlipOpen) {
    return HeaderType.MobileClosed;
  }

  return HeaderType.Default;
};

const BetSlipHeaderContent: React.FC = () => {
  const isClientAuthenticated = useSelector(select.session.isClientAuthenticated);

  const isBetSlipOpen = useSelector(select.betSlip.isOpen);
  const selectionsCount = useSelector(select.betSlip.selectionsCount);
  const { greaterThan } = useScreenSize();
  const isSmallScreen = !greaterThan(Size.Small);

  const headerType = getHeaderType(isSmallScreen, isBetSlipOpen, isClientAuthenticated);

  if (headerType === HeaderType.MobileAuthenticatedOpened) {
    return <OpenMobileBetSlipHeaderContent />;
  }

  if (headerType === HeaderType.MobileClosed) {
    return (
      <div className={styles.content}>
        <span className={classNames(styles.headerIcon, { [styles.betSlipOpen]: isBetSlipOpen })}>
          <Icon icon={Betslip} size="x1" />
        </span>
        <span className={classNames(styles.title, { [styles.betSlipOpen]: isBetSlipOpen })}>
          <Translation {...TXTWCL_Bet_Slip} />
        </span>
        {selectionsCount ? (
          <>
            <span className={styles.count}>{selectionsCount}</span>
            <BetSlipHeaderDetails />
          </>
        ) : null}
      </div>
    );
  }

  return (
    <ElementWithCount
      count={selectionsCount}
      element={
        <>
          <span className={classNames(styles.headerIcon, { [styles.betSlipOpen]: isBetSlipOpen })}>
            <Icon icon={Betslip} size="x1" />
          </span>
          <span className={classNames(styles.title, { [styles.betSlipOpen]: isBetSlipOpen })}>
            <Translation {...TXTWCL_Bet_Slip} />
          </span>
        </>
      }
    />
  );
};

export default BetSlipHeaderContent;
